const handleFormChange = (event, setForm) => {
	const { name, type, value, checked, files } = event.target;

	if (type === "file") {
		// Handle file input separately
		setForm((prev) => ({
			...prev,
			[name]: files[0],
		}));
	} else {
		// Handle other input types (text, checkbox, etc.)
		setForm((prev) => ({
			...prev,
			[name]: type === "checkbox" ? checked : value,
		}));
	}
};

export default handleFormChange;